import {Component, tag} from 'doz'

@tag('banner')
export default class extends Component {

    constructor(o) {
        super(o);

        this.props = {
            currentImageUrl: '',
            currentLink: '',
            items: []
        };

        this._lastIndex = 0;
    }

    template(h) {
        return h`
             <style> 
                .container {
                    padding: 0;
                    cursor: pointer;
                }
             </style>
             <div class="container animated fadeIn" d-show="${!!this.props.currentImageUrl}" onclick="${() => this.props.currentLink ? window.open(this.props.currentLink) : false}">
                <img src="${this.props.currentImageUrl}" style="width: 100%; display: block">
             </div>
        `
    }

    onMount() {
        this.nextElement();
    }

    nextElement() {
        // console.log(this.PLAYER_CONFIG)
        // console.log(this.props.items)
        if (!this.props.items.length) return;
        this._lastIndex = (this._lastIndex + 1) % this.props.items.length;
        let current = this.props.items[this._lastIndex];
        if (current.image_url) {
            this.props.currentImageUrl = current.image_url;
            this.props.currentLink = current.link;
        }
        setTimeout(() => {
            this.nextElement();
        }, current.timer * 1000)
    }
}
